(() => {
  const init = (root) => {
    if (!root || root.dataset.bvfInitialized === 'true') return;

    root.dataset.bvfInitialized = 'true';

    const reducedMotion =
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const revealItems =
      Array.from(
        root.querySelectorAll('[data-bvf-reveal]')
      );

    if (
      reducedMotion ||
      !('IntersectionObserver' in window)
    ) {
      revealItems.forEach((item) => {
        item.classList.add('is-bvf-visible');
      });
    } else {
      const observer =
        new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                entry.target.classList.add(
                  'is-bvf-visible'
                );

                observer.unobserve(
                  entry.target
                );
              }
            });
          },
          {
            threshold: 0.11,
            rootMargin: '0px 0px -8% 0px'
          }
        );

      revealItems.forEach((item) => {
        observer.observe(item);
      });
    }

    if (!reducedMotion) {
      const floatItems =
        root.querySelectorAll('[data-bvf-float]');

      const updateFloat = () => {
        const rect =
          root.getBoundingClientRect();

        const viewportHeight =
          window.innerHeight || 1;

        const progress =
          Math.max(
            -1,
            Math.min(
              1,
              (
                viewportHeight * 0.5 -
                rect.top
              ) / viewportHeight
            )
          );

        floatItems.forEach(
          (item, index) => {
            const amount =
              (index - 1) * 4;

            const y =
              progress * amount;

            item.style.transform =
              `translateY(${y}px)`;
          }
        );
      };

      let animationFrame = null;

      const onScroll = () => {
        if (animationFrame !== null) {
          return;
        }

        animationFrame =
          requestAnimationFrame(() => {
            animationFrame = null;
            updateFloat();
          });
      };

      window.addEventListener(
        'scroll',
        onScroll,
        { passive: true }
      );

      updateFloat();
    }
  };

  const initAll = () => {
    document
      .querySelectorAll('[data-bvf]')
      .forEach(init);
  };

  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      initAll,
      { once: true }
    );
  } else {
    initAll();
  }

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      const root =
        event.target.querySelector(
          '[data-bvf]'
        ) ||
        event.target.closest?.(
          '[data-bvf]'
        );

      init(root);
    }
  );
})();